import { j as r } from "../../../../../node_modules/react/jsx-runtime.js";
import { memo as g, useState as k, useMemo as b, createElement as n } from "react";
import { clsx as h } from "../../../../../node_modules/clsx/dist/clsx.m.js";
import c from "../../../../atoms/Button/Button.js";
import x from "../../../Dropdown/Dropdown.js";
import A from "../../../../atoms/ListItem/ListItem.js";
import u from "../../../../atoms/Tooltip/Tooltip.js";
import d from "../../Table.module.scss.js";
const C = ({ actions: t, data: i }) => {
  const [f, m] = k(!1), a = b(() => t.length > 3 ? t.slice(0, 2) : t, [t]), p = t.length > 3 ? t.slice(2) : [];
  return /* @__PURE__ */ r.jsxs("div", { className: h(d.tableActions, { [d.tableActionsOpen]: f }), children: [
    a.map((e, o) => {
      const s = () => {
        var l;
        (l = e.onClick) == null || l.call(e, i);
      };
      return /* @__PURE__ */ n(
        u,
        {
          ...e.tooltip,
          trigger: /* @__PURE__ */ r.jsx(
            c,
            {
              color: "neutral",
              ...e,
              onClick: s,
              iconOnly: !e.label,
              size: "small",
              variant: "tinted"
            }
          ),
          key: o
        }
      );
    }),
    p.length > 0 && /* @__PURE__ */ r.jsx(
      x,
      {
        position: "bottom-end",
        dropDownElement: /* @__PURE__ */ r.jsx(
          c,
          {
            iconOnly: !0,
            size: "small",
            leadingIcon: "dots-vertical",
            variant: "tinted",
            color: "neutral",
            testId: "more-actions-button",
            onClick: () => m(!0)
          }
        ),
        fitDropDown: !0,
        withPortal: !0,
        itemType: "button",
        onClose: () => m(!1),
        children: p.map((e, o) => {
          const s = () => {
            var l;
            (l = e.onClick) == null || l.call(e, i);
          };
          return /* @__PURE__ */ n(
            u,
            {
              placement: "left",
              ...e.tooltip,
              triggerWidth: "100%",
              trigger: /* @__PURE__ */ n(
                A,
                {
                  ...e,
                  key: o,
                  text: e.label ?? "",
                  onClick: s
                }
              ),
              key: o
            }
          );
        })
      }
    )
  ] });
}, E = g(C);
export {
  E as default
};
//# sourceMappingURL=TableActions.js.map
